import gql from 'graphql-tag';

export const GET_CALCULATED_REVENUE = gql`
  query VendorOpportunityCalculatedRevenue($input: VendorOpportunityCalculatedRevenueInput!) {
    vendorOpportunityCalculatedRevenue(input: $input) {
      vendorOpportunityId
      opportunityName
      dealer
      locationBranch
      salesRep
      dealDate
      dealAmount

      equipmentSalePrice
      equipmentCost
      equipmentGross
      equipmentMarginPercent

      financeUsed
      financeGross
      financeProfit
      financeMarginPercent
      internalFinanceTier
      lender
      docFeeAmount

      escSold
      escVendor
      escGross
      escCost
      escProfit

      gapSold
      gapVendor
      gapGross
      gapCost
      gapProfit

      insuranceSold
      insuranceVendor
      insuranceGross
      insuranceCost
      insuranceProfit

      roadsideSold
      roadsideVendor
      roadsideGross
      roadsideCost
      roadsideProfit
    }
  }
`;
